import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { media } from "@/lib/media";

export default function About() {
  const { t } = useLanguage();
  const stats = t("about.stats");

  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-sand py-24 sm:py-32"
    >
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 items-center gap-12 px-6 sm:px-10 lg:grid-cols-12 lg:gap-16">
        <div className="relative lg:col-span-5">
          <div className="relative overflow-hidden rounded-sm">
            <img
              src={media.about}
              alt="Blessed Algarve studio portrait"
              className="h-[520px] w-full object-cover sm:h-[620px]"
              style={{ objectPosition: "center 60%" }}
            />
          </div>
          <div className="pointer-events-none absolute -bottom-6 -right-4 hidden rounded-sm border border-warmBorder bg-sand px-6 py-4 font-display text-lg italic text-terracotta shadow-sm sm:block">
            “com a luz do sul”
          </div>
        </div>

        <div className="lg:col-span-7">
          <p className="overline mb-4">{t("about.overline")}</p>
          <h2
            data-testid="about-title"
            className="font-display text-4xl leading-tight text-ocean sm:text-5xl lg:text-6xl"
          >
            {t("about.title")}
          </h2>
          <p className="mt-8 max-w-xl text-base leading-relaxed text-ocean/80">
            {t("about.body")}
          </p>

          <div className="mt-12 grid grid-cols-3 gap-6 border-t border-warmBorder/70 pt-8">
            {stats.map((s, i) => (
              <div key={i} data-testid={`about-stat-${i}`}>
                <div className="font-display text-3xl text-terracotta sm:text-4xl">
                  {s.value}
                </div>
                <div className="mt-2 text-[11px] uppercase tracking-[0.24em] text-mutedText">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
